import markdownit from 'markdown-it';
const md = markdownit({ breaks: false });

// https://github.com/markdown-it/markdown-it/blob/master/docs/architecture.md#renderer
const rendererRules: Partial<typeof md.renderer.rules> = md.renderer.rules;
const defaultRender =
  rendererRules.link_open ??
  // eslint-disable-next-line max-params
  function (tokens, idx, options, _env, self) {
    return self.renderToken(tokens, idx, options);
  };

// eslint-disable-next-line max-params
md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
  // Add a new `target` attribute, or replace the value of the existing one.
  tokens[idx].attrSet('target', '_blank');

  // Pass the token to the default renderer.
  return defaultRender(tokens, idx, options, env, self);
};

export function useMarkdown() {
  function render(input: string): string {
    return md.render(input);
  }
  return { render };
}
